import ProductConfigurationProvider from './product-configuration-provider';

export const resolvedProductConfigurationProvider: ProductConfigurationProvider =
	new ProductConfigurationProvider();
